import { RawAjaxRequestHandler } from '@api/utils/RawAjaxRequestHandler'

/**
 * This crossFrame listener handles network calls in the IhmCandyCane Android environment.
 *
 * This is the JS-side of the interface with AuthPlugin plugin in the Cordova application.
 * That plugin intercepts any requests for client certificates and sets the correct one.
 */
export async function rawAjaxRequestListener (message: any) {
    return RawAjaxRequestHandler.listener(message)
}
